import { render, staticRenderFns } from "./custom_details.vue?vue&type=template&id=9a07b3da&scoped=true&"
import script from "./custom_details.vue?vue&type=script&lang=js&"
export * from "./custom_details.vue?vue&type=script&lang=js&"
import style0 from "./custom_details.vue?vue&type=style&index=0&id=9a07b3da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a07b3da",
  null
  
)

export default component.exports